// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-card-list .content-icon-location{margin-top:-5px}.custom-card-list{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:left}.custom-card-list .card-spacing{flex:0 0 25%}@media only screen and (max-width:768px){.custom-card-list .card-spacing{flex:0 0 33.333%}}@media only screen and (max-width:500px){.custom-card-list{gap:12px;padding:0 8px}.custom-card-list .card-spacing{flex:0 0 100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
